import jwt_decode, { type JwtPayload } from 'jwt-decode'

/**
 * Decodes the user id (`sub` claim) from an auth token without verifying its signature.
 * Returns null when the token is absent, malformed, or carries no `sub`.
 */
export const getTokenUserId = (token: unknown): string | null => {
  if (typeof token !== 'string' || !token) {
    return null
  }

  try {
    const { sub } = jwt_decode<JwtPayload>(token)

    return typeof sub === 'string' && sub ? sub : null
  } catch {
    return null
  }
}
